import * as angular from "angular";
import {GroupDetailController} from "./group-detail.controller";
const templateUrl = require("./group-detail.html");

export const groupDetail: angular.IComponentOptions = {
    templateUrl: templateUrl,
    controller: GroupDetailController,
    controllerAs: "vm",
    bindings: {}
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/group-detail/group-detail.ts
 **/